import { createUseStyles } from 'react-jss';

const styles = {
  profileListItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'AppShellBar'
});
